import React from 'react';
import RecommendEventSaveNavbar from '../RecommendEventSaveNavbar';
import RecommendEventSaveInfo from '../RecommendEventSaveInfo';
import RecommendEventSaveItemList from '../RecommendEventSaveItemList';
import './RecommendEventSaveWrap.scss';

const RecommendEventSaveWrap = (props) => {
  const {
    form,
    recommendEventSave,
    setData,
    getRecommendEventItemList,
    selectRecommendEventItemList,
    onSubmit,
    onDragEndSelectRecommendReviewItemList,
    getRecommendEventItemListExcelDownload,
    getSelectedRecommendEventItemListExcelDownload,
    setRecommendEventItemListExcelUpload,
    typeDisabled,
  } = props;
  const { recommendEventInfo, recommendEventItemList } = recommendEventSave;

  return (
    <div className="recommend-event-copy-wrap">
      {/* 하단 네브바 */}
      <RecommendEventSaveNavbar onSubmit={onSubmit} />

      {/* 추천 기획전 정보 */}
      <RecommendEventSaveInfo
        form={form}
        setData={setData}
        recommendEventInfo={recommendEventInfo}
        typeDisabled={typeDisabled}
      />

      {/* 추천 기획전 아이템 리스트*/}
      <RecommendEventSaveItemList
        recommendEventItemList={recommendEventItemList}
        getRecommendEventItemList={getRecommendEventItemList}
        selectRecommendEventItemList={selectRecommendEventItemList}
        onDragEndSelectRecommendReviewItemList={onDragEndSelectRecommendReviewItemList}
        getRecommendEventItemListExcelDownload={getRecommendEventItemListExcelDownload}
        getSelectedRecommendEventItemListExcelDownload={getSelectedRecommendEventItemListExcelDownload}
        setRecommendEventItemListExcelUpload={setRecommendEventItemListExcelUpload}
      />
    </div>
  );
};

export default RecommendEventSaveWrap;
